<template>
    <VcInputNumber
        v-model="model"
        :min-value="minValue"
        :max-value="maxValue"
        :step="1"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { VcInputNumber } from '@voicenter-team/voicenter-ui-plus'

const props = defineProps<{
    modelValue?: number | string
    minValue?: number
    maxValue?: number
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: number | string | undefined): void
}>()

const model = computed({
    get: () => props.modelValue !== undefined ? +props.modelValue : props.modelValue,
    set: (value) => {
        emit('update:modelValue', value)
    }
})

</script>

